/**
 * Alerts API - Location violation alerts management
 */

import { api } from './client'

/**
 * List location alerts for an organization
 *
 * @param {string} orgId - Organization UUID
 * @param {Object} options
 * @param {string} options.status - Filter by status: pending, reviewed, dismissed
 * @param {number} options.limit - Max results
 * @param {number} options.offset - Pagination offset
 * @returns {Promise<Object>} Paginated list of alerts
 */
export async function listAlerts(orgId, options = {}) {
  const params = new URLSearchParams()
  if (options.status) params.append('status', options.status)
  if (options.limit) params.append('limit', options.limit)
  if (options.offset) params.append('offset', options.offset)

  const queryString = params.toString()
  const url = `/organizations/${orgId}/alerts${queryString ? `?${queryString}` : ''}`
  return api.get(url)
}

/**
 * Get a specific alert
 *
 * @param {string} orgId - Organization UUID
 * @param {string} alertId - Alert UUID
 * @returns {Promise<Object>} Alert data
 */
export async function getAlert(orgId, alertId) {
  return api.get(`/organizations/${orgId}/alerts/${alertId}`)
}

/**
 * Update an alert's status
 *
 * @param {string} orgId - Organization UUID
 * @param {string} alertId - Alert UUID
 * @param {Object} updates
 * @param {string} updates.status - New status: pending, reviewed, dismissed
 * @param {string} updates.notes - Optional notes
 * @returns {Promise<Object>} Updated alert
 */
export async function updateAlertStatus(orgId, alertId, updates) {
  return api.patch(`/organizations/${orgId}/alerts/${alertId}`, updates)
}
